define('sidebar',[
  "jquery"
], function($) {
  $(".expand").click(function() {
    var $this = $(this);
    var aside = $this.closest("aside")
    var more = aside.find(".more");
    var isVisible = more.is(":visible");
    if (isVisible) {
      //move to the top
      var offset = aside.offset();
      $("body, html").animate({ scrollTop: offset.top });
    }
    $this.html( !isVisible ? "Read less &#9652;" : "Read more &#9662;" );
    more.slideToggle("slow");
  });
});
